import React from 'react';
import './DogCarousel.css';
import Carousel from 'nuka-carousel';
import useDogCarouselData from 'pages/DogDetail/DogCarousel/hooks/useDogCarouselData';
import { useModal } from 'modules/Modal/ModalProvider';
import Image from 'components/Image';

function DogCarousel({ dogId }) {
    const [imageUrls] = useDogCarouselData(dogId);
    const { openImageModal } = useModal();
    console.log(imageUrls)
    return (
        <div className={'dog-detail-carousel blur shadow'}>
            <Carousel
                className={'dog-detail-carousel__content'}
                defaultControlsConfig={{
                    containerClassName: 'carousel-container',
                    nextButtonClassName: 'carousel-next carousel-button',
                    prevButtonClassName: 'carousel-prev carousel-button',
                    pagingDotsClassName: 'carousel-dots',
                    nextButtonStyle: { background: 'red' },
                    nextButtonText: '>',
                    prevButtonText: '<',
                }}
            >
                {imageUrls.map(uri => (
                    <Image
                        onClick={() => openImageModal(uri)}
                        key={uri}
                        alt={'dog'}
                        className={'carousel-image'}
                        src={uri}
                    />
                ))}
            </Carousel>
        </div>
    );
}

export default DogCarousel;
